import {HttpService} from "../../common/api/httpService";
import {RequestResult} from "../../common/api/requestResult";
import {SteamLoginRequest} from "../../models/steam";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function getAuthMetaDataApi(): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestGetAsync(
        'auth/meta-data?isAdminPanel=true',
    );
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true, body);
    }
    return new RequestResult(false, body);
}

export async function steamLoginApi(req:SteamLoginRequest): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestPostAsync(
        'auth/steam-login',
        JSONbig.stringify(req)
    );
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true, body);
    }
    return new RequestResult(false, body);
}
